import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import translations from "../i18n/translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("medsim_lang") || "es";
  });

  useEffect(() => {
    localStorage.setItem("medsim_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => {
    const keys = key.split(".");
    let val = translations[lang];
    for (const k of keys) {
      if (val && val[k] !== undefined) {
        val = val[k];
      } else {
        return key;
      }
    }
    return val;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
